/**
 * Coure.Hub.Service.Creation
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AllVasServiceRevenueResponseDto } from '../model/allVasServiceRevenueResponseDto';
import { CreateVasServiceRevenueDto } from '../model/createVasServiceRevenueDto';
import { VasServiceRevenueResponseDto } from '../model/vasServiceRevenueResponseDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class VasServiceRevenueService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceRevenueCreateVasServiceRevenuePost(body?: CreateVasServiceRevenueDto, observe?: 'body', reportProgress?: boolean): Observable<VasServiceRevenueResponseDto>;
    public apiVasServiceRevenueCreateVasServiceRevenuePost(body?: CreateVasServiceRevenueDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VasServiceRevenueResponseDto>>;
    public apiVasServiceRevenueCreateVasServiceRevenuePost(body?: CreateVasServiceRevenueDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VasServiceRevenueResponseDto>>;
    public apiVasServiceRevenueCreateVasServiceRevenuePost(body?: CreateVasServiceRevenueDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<VasServiceRevenueResponseDto>('post',`${this.basePath}/api/VasServiceRevenue/CreateVasServiceRevenue`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param revenueId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceRevenueDeleteServiceRevenueRevenueIdDelete(revenueId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiVasServiceRevenueDeleteServiceRevenueRevenueIdDelete(revenueId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiVasServiceRevenueDeleteServiceRevenueRevenueIdDelete(revenueId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiVasServiceRevenueDeleteServiceRevenueRevenueIdDelete(revenueId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (revenueId === null || revenueId === undefined) {
            throw new Error('Required parameter revenueId was null or undefined when calling apiVasServiceRevenueDeleteServiceRevenueRevenueIdDelete.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/VasServiceRevenue/DeleteServiceRevenue/${encodeURIComponent(String(revenueId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceRevenueGetAllServiceRevenueGet(observe?: 'body', reportProgress?: boolean): Observable<AllVasServiceRevenueResponseDto>;
    public apiVasServiceRevenueGetAllServiceRevenueGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AllVasServiceRevenueResponseDto>>;
    public apiVasServiceRevenueGetAllServiceRevenueGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AllVasServiceRevenueResponseDto>>;
    public apiVasServiceRevenueGetAllServiceRevenueGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AllVasServiceRevenueResponseDto>('get',`${this.basePath}/api/VasServiceRevenue/GetAllServiceRevenue`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param vasServiceId 
     * @param revenueId 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceRevenueGetServiceRevenueByVasServiceIdAndRevenueIdVasServiceIdRevenueIdGet(vasServiceId: string, revenueId: string, skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<VasServiceRevenueResponseDto>;
    public apiVasServiceRevenueGetServiceRevenueByVasServiceIdAndRevenueIdVasServiceIdRevenueIdGet(vasServiceId: string, revenueId: string, skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VasServiceRevenueResponseDto>>;
    public apiVasServiceRevenueGetServiceRevenueByVasServiceIdAndRevenueIdVasServiceIdRevenueIdGet(vasServiceId: string, revenueId: string, skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VasServiceRevenueResponseDto>>;
    public apiVasServiceRevenueGetServiceRevenueByVasServiceIdAndRevenueIdVasServiceIdRevenueIdGet(vasServiceId: string, revenueId: string, skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (vasServiceId === null || vasServiceId === undefined) {
            throw new Error('Required parameter vasServiceId was null or undefined when calling apiVasServiceRevenueGetServiceRevenueByVasServiceIdAndRevenueIdVasServiceIdRevenueIdGet.');
        }

        if (revenueId === null || revenueId === undefined) {
            throw new Error('Required parameter revenueId was null or undefined when calling apiVasServiceRevenueGetServiceRevenueByVasServiceIdAndRevenueIdVasServiceIdRevenueIdGet.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<VasServiceRevenueResponseDto>('get',`${this.basePath}/api/VasServiceRevenue/GetServiceRevenueByVasServiceIdAndRevenueId/${encodeURIComponent(String(vasServiceId))}/${encodeURIComponent(String(revenueId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param revenueId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceRevenueGetVasServiceRevenueByRevenueIdRevenueIdGet(revenueId: string, observe?: 'body', reportProgress?: boolean): Observable<VasServiceRevenueResponseDto>;
    public apiVasServiceRevenueGetVasServiceRevenueByRevenueIdRevenueIdGet(revenueId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VasServiceRevenueResponseDto>>;
    public apiVasServiceRevenueGetVasServiceRevenueByRevenueIdRevenueIdGet(revenueId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VasServiceRevenueResponseDto>>;
    public apiVasServiceRevenueGetVasServiceRevenueByRevenueIdRevenueIdGet(revenueId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (revenueId === null || revenueId === undefined) {
            throw new Error('Required parameter revenueId was null or undefined when calling apiVasServiceRevenueGetVasServiceRevenueByRevenueIdRevenueIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<VasServiceRevenueResponseDto>('get',`${this.basePath}/api/VasServiceRevenue/GetVasServiceRevenueByRevenueId/${encodeURIComponent(String(revenueId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param vasServiceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceRevenueGetVasServiceRevenueByVasServiceIdVasServiceIdGet(vasServiceId: string, observe?: 'body', reportProgress?: boolean): Observable<VasServiceRevenueResponseDto>;
    public apiVasServiceRevenueGetVasServiceRevenueByVasServiceIdVasServiceIdGet(vasServiceId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VasServiceRevenueResponseDto>>;
    public apiVasServiceRevenueGetVasServiceRevenueByVasServiceIdVasServiceIdGet(vasServiceId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VasServiceRevenueResponseDto>>;
    public apiVasServiceRevenueGetVasServiceRevenueByVasServiceIdVasServiceIdGet(vasServiceId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (vasServiceId === null || vasServiceId === undefined) {
            throw new Error('Required parameter vasServiceId was null or undefined when calling apiVasServiceRevenueGetVasServiceRevenueByVasServiceIdVasServiceIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<VasServiceRevenueResponseDto>('get',`${this.basePath}/api/VasServiceRevenue/GetVasServiceRevenueByVasServiceId/${encodeURIComponent(String(vasServiceId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
